import angular from 'angular';
import { SmartyStreetsService } from './smartystreets.service';

export const SmartyStreetsModule = angular
  .module('angular-common.address.smartystreets', [])
  .service('updSmartyStreetsService', SmartyStreetsService);
